import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
import { PriceDisplay } from './PriceDisplay';
export function OfferSummary() {
  return <section className="py-16 px-4 bg-white" data-id="element-208">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-8 items-center" data-id="element-209">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white rounded-3xl p-8 md:p-10 border-4 border-relief shadow-2xl relative" data-id="element-210">
          <h2 className="font-display font-bold text-3xl text-teal mb-6 text-center border-b border-sage/20 pb-6" data-id="element-211">
            Hoy obtienes:
          </h2>

          <ul className="space-y-4 mb-8 font-sans" data-id="element-212">
            {['Sistema de Reprogramación Interna de 30 Días™', 'Checklist Integral de Implementación', 'Mapa Personal de Regulación', 'BONO: Plan Anti-Crisis', 'BONO: Rutina Nocturna Restauradora', 'Garantía de 30 días sin preguntas', 'Acceso inmediato tras la compra'].map((item, i) => <li key={i} className="flex items-start" data-id="element-213">
                <CheckCircle2 className="text-relief mr-3 shrink-0 mt-0.5" size={20} data-id="element-214" />
                <span className={item.includes('BONO') ? 'font-bold text-teal' : 'text-neutral-gray font-medium'} data-id="element-215">
                  {item}
                </span>
              </li>)}
          </ul>

          <div className="bg-beige rounded-xl p-6 text-center border border-sage/30" data-id="element-216">
            <p className="text-neutral-gray text-lg mb-2" data-id="element-217">
              Valor total:{' '}
              <PriceDisplay amountUSD={67} className="line-through text-gold font-bold" data-id="element-218" />
            </p>
            <div className="flex items-baseline justify-center gap-2 mb-2" data-id="element-219">
              <span className="text-xl text-teal font-medium" data-id="element-220">
                Hoy pagas solo:
              </span>
              <PriceDisplay amountUSD={9.99} className="font-heading font-bold text-3xl text-teal" data-id="element-221" />
            </div>
            <p className="text-relief font-bold text-sm" data-id="element-222">
              Ahorro: $57 USD (85% de descuento)
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} className="hidden md:block" data-id="element-223">
          <img src="https://cdn.magicpatterns.com/uploads/vdg7zhLv8TFLwV6PqxTVZj/1._Oferta.png" alt="Todo esto es tuyo hoy - Sistema completo, Mapa Personal, Checklist Integral, Plan Anti-Crisis y Rutina Nocturna por solo $9,99 USD" className="w-full rounded-2xl shadow-lg" data-id="element-224" />
        </motion.div>
      </div>
    </section>;
}